import React, { Component } from 'react'
import { Card } from 'react-bootstrap'
import { IconButton, CircularProgress } from '@material-ui/core'
import CancelIcon from '@material-ui/icons/Cancel'
import * as actions from '../actions/TablaMovimientosMercaderiaActions'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { FORM_TAREA_MOVIMIENTO } from '../../../../../config/forms'
import { INTERVALO_CORTO } from '../../../../../config/settings'
import { ToastContainer } from 'react-toastify'
import UpdateTarea from './UpdateTarea'

class DialogoTareasUpdate extends Component {
  componentDidMount () {
    const { fechaRegistroTarea } = this.props
    this.props.tareaPorFecha(fechaRegistroTarea)
  }

  render () {
    const {
      handleSubmit,
      handleClose,
      tareaInicial
    } = this.props

    return (
      <div>
        <ToastContainer autoClose={INTERVALO_CORTO} />
        <Card style={{ border: 'none' }}>
          <Card.Header style={{ backgroundColor: '#3f51b5', color: '#ffffff' }}>
            <IconButton onClick={handleClose} style={{ margin: '0', padding: '0', float: 'right' }}>
              <CancelIcon style={{ color: '#ffffff' }} />
            </IconButton>
          </Card.Header>
          <Card.Body>
            <Card.Text style={{ fontSize: '1.3rem', textAlign: 'center' }}>Edición tarea de movimiento de mercadería</Card.Text>
            {tareaInicial && <UpdateTarea tareaInicial={tareaInicial} handleSubmit={handleSubmit} /> }
            {!tareaInicial && <div style={{ padding: '10% 0', margin: '0 auto' }} >
              <CircularProgress />
            </div> }
          </Card.Body>
        </Card>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    tareaInicial: state.cuadroDeMandoMovimientos.tareaInicial
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_TAREA_MOVIMIENTO,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(DialogoTareasUpdate))
